// extracted by mini-css-extract-plugin
module.exports = {"container":"modal_styles_container__7MCGn","box":"modal_styles_box__OgmVn","content":"modal_styles_content__HwAbB"};